import { MigrationDefinition } from './migration.types';

/**
 * Migration: undefined (-1) → V0
 *
 * Upgrade:
 * - quality Default auf 1 setzen
 * - Horizontfolge maechtigkeit Default auf 0 setzen
 * - bodenform.hauptbodenform/feinbodenform → bodenform.bf[] Array
 *
 * Downgrade:
 * - bodenform.bf[] → bodenform.hauptbodenform/feinbodenform (nur erstes Element)
 * - version auf undefined setzen
 */
export const migrationV_1ToV0: MigrationDefinition = {
  fromVersion: -1,
  toVersion: 0,

  upgrade(doc: any): any {
    if (!doc.quality) {
      doc.quality = 1;
    }

    doc.Horizontfolge?.forEach((row: any) => {
      if (!row.maechtigkeit) row.maechtigkeit = 0;
    });

    if (doc.header?.bodenform?.hauptbodenform !== undefined) {
      const hbf = doc.header.bodenform.hauptbodenform;
      const fbf = doc.header.bodenform.feinbodenform;
      doc.header.bodenform.bf = [{ hbf: hbf, fbf: fbf }];
      delete doc.header.bodenform.hauptbodenform;
      delete doc.header.bodenform.feinbodenform;
    }

    doc.version = 0;
    return doc;
  },

  downgrade(doc: any): any {
    // bodenform.bf[] zurück zu hauptbodenform/feinbodenform
    if (doc.header?.bodenform?.bf?.length > 0) {
      const first = doc.header.bodenform.bf[0];
      doc.header.bodenform.hauptbodenform = first.hbf;
      doc.header.bodenform.feinbodenform = first.fbf;
      // bf Array BEHALTEN - alte App ignoriert es, aber Daten bleiben für späteres Upgrade
    }

    delete doc.version; // undefined für unversionierte Dokumente
    return doc;
  },

  dataLossWarnings: [
    'Bei mehreren Bodenformen (bf[]) wird nur die erste zu hauptbodenform/feinbodenform konvertiert'
  ]
};
